__turbopack_context__.v({
  "backLink": "BlockSubCategoryIntro-module-scss-module__qy5PJa__backLink",
  "backLinkIcon": "BlockSubCategoryIntro-module-scss-module__qy5PJa__backLinkIcon",
  "ctaGroup": "BlockSubCategoryIntro-module-scss-module__qy5PJa__ctaGroup",
  "description": "BlockSubCategoryIntro-module-scss-module__qy5PJa__description",
  "fade-in": "BlockSubCategoryIntro-module-scss-module__qy5PJa__fade-in",
  "headline": "BlockSubCategoryIntro-module-scss-module__qy5PJa__headline",
  "heroImage": "BlockSubCategoryIntro-module-scss-module__qy5PJa__heroImage",
  "imageColumn": "BlockSubCategoryIntro-module-scss-module__qy5PJa__imageColumn",
  "intro-in": "BlockSubCategoryIntro-module-scss-module__qy5PJa__intro-in",
  "root": "BlockSubCategoryIntro-module-scss-module__qy5PJa__root",
  "textBlock": "BlockSubCategoryIntro-module-scss-module__qy5PJa__textBlock",
  "textColumn": "BlockSubCategoryIntro-module-scss-module__qy5PJa__textColumn",
});
